import { IconNames, Text } from '@dixa/lib-shared-habla';
import { boundMethod } from 'autobind-decorator';
import { v4 as uuid } from 'uuid';

import { formatPortsHelper } from 'components/powerFlowShared/helpers/nodePortFormatter';
import {
  FlowNode,
  flowNodeColor,
  InternalPortT,
  NodeT,
  NodeTypeComponent,
  RegisterPortT,
} from 'fable/flowEditor';
import { AutomationNodeTypes } from 'hocs';
import { durationConverter } from 'utils/duration';

import { WaitModal } from '../modals/wait';
import type { AutomationFlowExtraDataT } from '../types';

export type AutomationNodeWaitPayloadT = {
  delayInSeconds: number;
  matchNodeId: string;
  nonMatchNodeId: string;
};
export type AutomationNodeWaitTypeT = AutomationNodeTypes.WAIT;
export type AutomationNodeWaitT = NodeT<
  AutomationNodeWaitTypeT,
  AutomationNodeWaitPayloadT
>;

const waitActionFormatter = (
  node: AutomationNodeWaitT,
): Array<RegisterPortT> => [
  {
    id: uuid(),
    type: 'out',
    label: 'Trigger false',
    connection: node.payload.nonMatchNodeId || uuid(),
  },
  {
    id: uuid(),
    type: 'out',
    label: 'Trigger still true',
    connection: node.payload.matchNodeId || uuid(),
  },
];

export class WaitNode extends NodeTypeComponent<
  AutomationNodeWaitT,
  AutomationFlowExtraDataT
>() {
  static icon: IconNames = 'calendar';
  static label = 'Wait';
  static color = flowNodeColor.purple;
  static translatePayload = formatPortsHelper(waitActionFormatter);
  static ActionModal = WaitModal;
  static actionTrigger = { type: AutomationNodeTypes.WAIT };
  static updateConnection = (
    node: AutomationNodeWaitT,
    port: InternalPortT,
    newConnection: string,
  ): AutomationNodeWaitT => {
    const payload = { ...node.payload };
    payload[
      port.label === 'Trigger still true' ? 'matchNodeId' : 'nonMatchNodeId'
    ] = newConnection;
    return { ...node, payload };
  };

  @boundMethod
  triggerEdit(): void {
    const { onEdit, node } = this.props;
    onEdit(node, node.nodeType);
  }

  render() {
    const { node } = this.props;
    const waitTimeString = durationConverter.toString(
      node.payload.delayInSeconds,
    );

    return (
      <FlowNode
        color={WaitNode.color}
        icon={WaitNode.icon}
        label={WaitNode.label}
        text={
          <Text.Paragraph clamp={1} variant="1">
            {waitTimeString}
          </Text.Paragraph>
        }
        onEdit={this.triggerEdit}
      />
    );
  }
}
